"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTag = exports.findTagAttribute = exports.findTagText = exports.findTagArray = void 0;
var lodash_1 = require("lodash");
var xml_utils_1 = require("xml-utils");
function findTagArray(xml, tagNameOrPath) {
    return (0, xml_utils_1.findTagsByPath)(xml, (0, lodash_1.castArray)(tagNameOrPath))
        .filter(function (tag) { return tag.inner !== null; })
        .map(function (tag) { return tag.inner; });
}
exports.findTagArray = findTagArray;
function findTagText(xml, tagName) {
    var tag = (0, xml_utils_1.findTagByName)(xml, tagName);
    return (tag === null || tag === void 0 ? void 0 : tag.inner) || undefined;
}
exports.findTagText = findTagText;
function findTagAttribute(xml, tagNameOrPath, attribute) {
    var tag = (0, xml_utils_1.findTagByPath)(xml, (0, lodash_1.castArray)(tagNameOrPath));
    if (!tag) {
        return undefined;
    }
    var value = (0, xml_utils_1.getAttribute)(tag, attribute);
    if (value) {
        return value;
    }
    return undefined;
}
exports.findTagAttribute = findTagAttribute;
function hasTag(xml, tagNameOrPath) {
    return (0, xml_utils_1.findTagsByPath)(xml, (0, lodash_1.castArray)(tagNameOrPath)).length > 0;
}
exports.hasTag = hasTag;
